<template>
  <div class="content-page">
    <div class="tab-header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/goods' }">商品管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{
          goodsForm.goodsId ? "编辑商品" : "新建商品"
        }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="tab-content">
      <el-form
        :model="goodsForm"
        :rules="rules"
        ref="goodsForm"
        label-width="108px"
        class="demo-goodsForm"
        :hide-required-asterisk="true"
      >
        <el-form-item label="商品图片" prop="goodsImage">
          <div>
            <el-upload
              :disabled="true"
              action="/ImageServer/YmUpload_image"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="
                (e) => {
                  handleRemove(e, 'goodsImage');
                }
              "
              :http-request="
                (e) => {
                  handleSuccess(e, 'goodsImage');
                }
              "
              :before-upload="beforeImgUpload"
              :on-exceed="limitTip"
              :file-list="fileList"
              :limit="1"
              :on-change="handleEditChange"
              :class="{ hide: hideUpload }"
            >
              <div
                style="width: 148px; height: 148px; position: absolute"
                @click="show_uploadDialog(1, 'goodsImage')"
              ></div>
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt />
            </el-dialog>
            <span class="tips">建议宽高比1:1，大小小于3M商品图</span>
          </div>
        </el-form-item>
        <el-form-item label="轮播图">
          <div>
            <el-upload
              :disabled="uploadDisabled"
              action="/ImageServer/YmUpload_image"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="
                (e) => {
                  handleRemove(e, 'goodsImages');
                }
              "
              :http-request="
                (e) => {
                  handleSuccess(e, 'goodsImages');
                }
              "
              :before-upload="beforeImgUpload"
              :file-list="goodsImages"
              :before-remove="beforeRemove"
            >
              <div
                style="width: 148px; height: 148px; position: absolute"
                @click="show_uploadDialog(999, 'goodsImages')"
              ></div>
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt />
            </el-dialog>
            <span class="tips">建议宽高比1:1，大小小于3M商品图</span>
          </div>
        </el-form-item>
        <el-form-item label="商品多图">
          <div>
            <el-upload
              :disabled="uploadDisabled"
              action="/ImageServer/YmUpload_image"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="
                (e) => {
                  handleRemove(e, 'goodsDescriptionImages');
                }
              "
              :http-request="
                (e) => {
                  handleSuccess(e, 'goodsDescriptionImages');
                }
              "
              :before-upload="beforeImgUpload"
              :file-list="goodsDescriptionImages1"
              :before-remove="beforeRemove"
            >
              <div
                style="width: 148px; height: 148px; position: absolute"
                @click="show_uploadDialog(999, 'goodsDescriptionImages')"
              ></div>
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt />
            </el-dialog>
            <span class="tips">建议宽高比1:1，大小小于3M商品图</span>
          </div>
        </el-form-item>
        <el-form-item label="商品名称" prop="goodsName">
          <el-input
            v-model.trim="goodsForm.goodsName"
            placeholder="请填写商品名称"
            maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="商品分类"
          prop="goodsCategoryId"
          v-if="classifyOptionsNoGroup.length"
        >
          <el-cascader
            v-model="goodsCategoryCascaderValue"
            :options="categoryCascaderOptions"
            :props="categoryCascaderProps"
            clearable
            filterable
            placeholder="请选择"
            @change="handleGoodsCategoryChange"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="商品描述" maxlength="100">
          <el-input
            type="textarea"
            placeholder="请填写商品描述"
            v-model.trim="goodsForm.goodsDescription"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品条码" maxlength="100">
          <el-input
            placeholder="请填写商品条形码"
            v-model.trim="goodsForm.goodsBarCode"
          ></el-input>
        </el-form-item>
        <el-form-item label="单位类型" maxlength="100">
          <el-radio-group v-model="goodsForm.unitType">
            <el-radio :label="1">计数</el-radio>
            <el-radio :label="2">计重</el-radio>
            <el-radio :label="3">计例</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="商品单位"
          v-show="isShowCanSaleOfflineAndCountRelated"
          prop="goodsUnitId"
        >
          <el-select v-model="goodsForm.goodsUnitId" placeholder="请选择商品单位">
            <el-option
              v-for="item in goodsUnitList"
              :key="item.goodsUnitId"
              :label="item.goodsUnit"
              :value="item.goodsUnitId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="商品单位"
          v-show="!isShowCanSaleOfflineAndCountRelated"
          prop="unit"
        >
          <el-input v-model.trim="goodsForm.unit" placeholder="如：份、斤"></el-input>
        </el-form-item>
        <el-form-item label="月销基数" prop="baseSales">
          <el-input
            placeholder="填写月销基数"
            v-model="goodsForm.baseSales"
            size="small"
            clearable
            type="number"
            min="0"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="商品最少购买数量"
          prop="minBuyNum"
          v-show="!goodsForm.isPromote"
        >
          <el-input
            placeholder="填写商品最少购买数量(0为不限制)"
            v-model="goodsForm.minBuyNum"
            size="small"
            clearable
            type="number"
            min="0"
          ></el-input>
        </el-form-item>
        <el-form-item label="必选菜品" prop="isRequired">
          <el-radio-group v-model="goodsForm.isRequired">
            <el-radio :label="0">非必选</el-radio>
            <el-radio :label="1">必选（1人1份）</el-radio>
            <el-radio :label="2">必选（1桌一份）</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="商品分组" prop="groupIds" v-if="groupOptions.length">
          <el-checkbox-group v-model="goodsForm.groupIds" size="small">
            <el-checkbox
              v-for="item in groupOptions"
              :key="item.goodsCategoryId"
              :label="`${item.goodsCategoryId}`"
              :disabled="
                goodsForm.groupIds.length &&
                !~goodsForm.groupIds.indexOf(`${item.goodsCategoryId}`)
              "
              >{{ item.categoryName }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="活动商品" prop="isPromote">
          <el-radio-group v-model="goodsForm.isPromote">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="快速退菜" prop="refundNoAuth">
          <el-radio-group v-model="goodsForm.refundNoAuth">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="推荐商品"
          prop="isRecommend"
          v-if="shopInfo.edcShopType != 8"
        >
          <el-radio-group v-model="goodsForm.isRecommend">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="支持超卖" prop="isOversold">
                    <el-radio-group v-model="goodsForm.isOversold">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item> -->
        <el-form-item label="商品标签" prop="goodsLabel">
          <el-checkbox-group v-model="goodsForm.goodsLabel" size="small">
            <el-checkbox label="1">招牌</el-checkbox>
            <el-checkbox label="2">新菜</el-checkbox>
            <el-checkbox label="3">辣</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="是否参与打折" prop="isCanDiscount">
          <el-radio-group v-model="goodsForm.isCanDiscount">
            <el-radio :label="0">参与</el-radio>
            <el-radio :label="1">不参与</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="单点不送" prop="isSingleNoDelivery">
          <el-radio-group v-model="goodsForm.isSingleNoDelivery">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="虚拟物品" prop="isFictitious">
          <el-radio-group v-model="goodsForm.isFictitious">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="售卖范围" prop="saleAreaType">
          <el-radio-group v-model="goodsForm.saleAreaType">
            <el-radio :label="0">都支持</el-radio>
            <el-radio :label="1">仅堂食</el-radio>
            <el-radio :label="2">仅外卖</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="组合类型" maxlength="100" v-if="shopInfo.edcShopType == 3">
          <el-radio-group v-model="goodsForm.goodsType">
            <el-radio :label="1">普通商品</el-radio>
            <el-radio :label="2">组合商品</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item
          label="支持线下销售"
          maxlength="100"
          v-if="shopInfo.edcShopType == 4"
        >
          <el-radio-group v-model="goodsForm.isCanSaleOffline">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="商品规格" prop="products">
          <div class="custom-form">
            <div class="form-header">
              <div
                class="fixed-width"
                v-show="isAddGoodsSpec && goodsForm.goodsType != 2"
              >
                商品规格
              </div>
              <div class="fixed-width">价格</div>
              <div class="fixed-width" v-show="isShowCanSaleOfflineRelated">原价</div>
              <div class="fixed-width" v-show="isShowCanSaleOfflineRelated">进货价</div>
              <div class="fixed-width">
                餐盒费<span class="tips">(餐盒费参与会员打折)</span>
              </div>
              <div class="fixed-width">会员价</div>
              <div class="fixed-width" v-show="isShowCanSaleOfflineAndCountRelated">
                商品单位
              </div>
              <div class="fixed-width" v-show="isAddGoodsSpec">条码</div>
              <div class="indefinite-width">库存</div>
            </div>
            <div class="form-content">
              <div
                class="item"
                v-for="(item, index) in goodsForm.goodsType == 2
                  ? [goodsForm.products[0]]
                  : goodsForm.products"
                :key="index"
              >
                <div
                  class="fixed-width"
                  v-show="isAddGoodsSpec && goodsForm.goodsType != 2"
                >
                  <el-input
                    placeholder="如：大份"
                    v-model="item.valueContent"
                    size="small"
                    clearable
                  ></el-input>
                </div>
                <div class="fixed-width">
                  <el-input
                    placeholder="填写价格"
                    v-model="item.retailPrice"
                    size="small"
                    @input.native="numberInputChange"
                    @blur="numberInputBlur"
                    clearable
                    type="number"
                    min="0"
                  ></el-input>
                </div>
                <div class="fixed-width" v-show="isShowCanSaleOfflineRelated">
                  <el-input
                    placeholder="填写原价"
                    v-model="item.costPrice"
                    size="small"
                    @input.native="numberInputChange"
                    @blur="numberInputBlur"
                    clearable
                    type="number"
                    min="0"
                  ></el-input>
                </div>
                <div class="fixed-width" v-show="isShowCanSaleOfflineRelated">
                  <el-input
                    placeholder="填写进货价"
                    v-model="item.takePrice"
                    size="small"
                    @input.native="numberInputChange"
                    @blur="numberInputBlur"
                    clearable
                    type="number"
                    min="0"
                  ></el-input>
                </div>
                <div class="fixed-width">
                  <el-input
                    placeholder="填写餐盒费"
                    v-model="item.foodBoxPrice"
                    @input.native="numberInputChange"
                    @blur="numberInputBlur"
                    size="small"
                    clearable
                    type="number"
                    min="0"
                  ></el-input>
                </div>
                <div class="fixed-width">
                  <el-input
                    placeholder="填写会员价格"
                    v-model="item.memberPrice"
                    size="small"
                    @input.native="numberInputChange"
                    @blur="numberInputBlur"
                    clearable
                    type="number"
                    min="0"
                  ></el-input>
                </div>
                <div class="fixed-width" v-show="isShowCanSaleOfflineAndCountRelated">
                  <el-select
                    size="small"
                    v-model="item.goodsUnitId"
                    placeholder="请选择商品单位"
                  >
                    <el-option
                      v-for="item in goodsUnitList"
                      :key="item.goodsUnitId"
                      :label="item.goodsUnit"
                      :value="item.goodsUnitId"
                    ></el-option>
                  </el-select>
                </div>
                <div class="fixed-width" v-show="isAddGoodsSpec">
                  <el-input
                    placeholder="请填写条形码"
                    v-model="item.barCode"
                    size="small"
                    clearable
                  ></el-input>
                </div>
                <div class="indefinite-width">
                  <el-radio-group v-model="item.stockType">
                    <!-- <el-radio label="infinite">无限库存</el-radio> -->
                    <el-radio label="custom">自定义库存</el-radio>
                  </el-radio-group>
                  <el-input
                    v-show="item.stockType == 'custom'"
                    placeholder="输入库存"
                    v-model="item.stockCount"
                    @blur="stockCountInputBlur"
                    size="small"
                    clearable
                    type="number"
                    min="0"
                  ></el-input>
                  <el-button
                    type="text"
                    v-if="isAddGoodsSpec && goodsForm.goodsType != 2"
                    @click="delGoodsSpec(index)"
                    >删除</el-button
                  >
                </div>
              </div>
            </div>
            <el-button
              v-show="goodsForm.isRequired == 0 && goodsForm.goodsType == 1"
              type="primary"
              size="small"
              @click="addGoodsSpec"
              >添加规格</el-button
            >
          </div>
          <div v-show="goodsForm.goodsType == 2">
            <div
              class="custom-form combined"
              v-for="(group, gIndex) in goodsForm.productDetail"
              :key="gIndex"
              style="margin-bottom: 20px"
            >
              <div
                class="group-header"
                style="
                  padding: 10px 20px;
                  background: #f8f8f8;
                  display: flex;
                  align-items: center;
                  flex-wrap: wrap;
                "
              >
                <el-input
                  v-model="group.groupName"
                  placeholder="分组名称"
                  size="small"
                  style="width: 200px; margin-right: 20px; margin-bottom: 5px"
                ></el-input>
                <el-checkbox
                  :true-label="1"
                  :false-label="0"
                  v-model="group.isRepeatable"
                  style="margin-right: 20px; margin-bottom: 5px"
                  >可重复选择</el-checkbox
                >
                <span style="margin-right: 10px; margin-bottom: 5px">可选数量</span>
                <el-select
                  v-model="group.minSelect"
                  size="small"
                  style="width: 120px; margin-right: 20px; margin-bottom: 5px"
                >
                  <el-option
                    v-for="n in group.items.length || 1"
                    :key="'min' + n"
                    :label="
                      getGroupTotalComboCount(group) + '选' + (group.items.length - n + 1)
                    "
                    :value="group.items.length - n + 1"
                  ></el-option>
                  <!-- <el-option
                    :label="getGroupTotalComboCount(group) + '选0 (可选)'"
                    :value="0"
                  ></el-option> -->
                </el-select>
                <el-button
                  type="text"
                  style="margin-left: auto; color: #f56c6c"
                  @click="delGroup(gIndex)"
                  >删除分组</el-button
                >
              </div>
              <div class="form-header">
                <div class="fixed-width">子商品名称</div>
                <div class="fixed-width">单位</div>
                <div class="fixed-width">组合数量</div>
                <div class="fixed-width">小计</div>
                <div class="indefinite-width">操作</div>
              </div>
              <div class="form-content">
                <div class="item" v-for="(item, index) in group.items" :key="index">
                  <div class="fixed-width">
                    {{ item.goodsName }}
                  </div>
                  <div class="fixed-width">{{ item.goodsUnit }}</div>
                  <div class="fixed-width">
                    <el-input-number
                      v-model="item.comboCount"
                      :min="1"
                      :step="1"
                      step-strictly
                      size="small"
                      disabled
                    ></el-input-number>
                  </div>
                  <div class="fixed-width">
                    {{ (item.comboCount * item.retailPrice).toFixed(2) }}
                  </div>
                  <div class="indefinite-width">
                    <el-button type="text" @click="delProductDetail(gIndex, index)"
                      >删除</el-button
                    >
                  </div>
                </div>
                <el-link type="primary" :underline="false" @click="selGoods(gIndex)"
                  ><i class="el-icon-plus"></i>选择商品</el-link
                >
              </div>
            </div>
            <el-button type="primary" size="small" @click="addGroup">添加分组</el-button>
          </div>
        </el-form-item>
        <el-form-item label="商品属性" prop="freeSpecs" v-if="goodsForm.isRequired == 0">
          <div class="custom-form">
            <div class="form-header">
              <div class="fixed-width">属性名称</div>
              <div class="indefinite-width">属性值</div>
            </div>
            <div class="form-content">
              <div class="item" v-for="(item, index) in goodsForm.freeSpecs" :key="index">
                <div class="fixed-width">
                  <el-input
                    placeholder="如：大份"
                    v-model="item.name"
                    size="small"
                    clearable
                  ></el-input>
                </div>
                <div class="indefinite-width">
                  <el-tag
                    :key="tagindex"
                    v-for="(tag, tagindex) in item.value"
                    closable
                    :disable-transitions="false"
                    @close="handleClose(tag, index)"
                    >{{ tag }}</el-tag
                  >
                  <el-input
                    class="input-new-tag"
                    v-if="item.attrValueInputVisible"
                    v-model="item.attrValueInputValue"
                    :ref="`saveTagInput${index}`"
                    size="small"
                    @keyup.enter.native="handleAttrValueInputConfirm(index)"
                    @blur="handleAttrValueInputConfirm(index)"
                  ></el-input>
                  <el-button
                    v-else
                    class="button-new-tag"
                    size="small"
                    @click="showAttrValueInput(index)"
                    >+ 添加</el-button
                  >
                  <el-button
                    type="text"
                    v-if="goodsForm.freeSpecs.length > 1"
                    @click="delGoodsAttr(index)"
                    >删除</el-button
                  >
                </div>
              </div>
            </div>
            <el-button type="primary" size="small" @click="addGoodsAttr"
              >添加属性</el-button
            >
          </div>
        </el-form-item>
        <el-form-item label="商品链接" maxlength="100" v-if="goodsForm.goodsId">
          <el-input
            disabled
            readOnly
            :value="`pages/goodsDetails/goodsDetails?goodsId=${goodsForm.goodsId}`"
          />
          <input
            class="goodsUrl"
            :value="`pages/goodsDetails/goodsDetails?goodsId=${goodsForm.goodsId}`"
          />
          <el-button type="primary" @click="copyGoodsUrl">复制</el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="submitForm('goodsForm')"
            :loading="isSubmit"
            >{{ goodsForm.goodsId ? "提交编辑" : "立即创建" }}</el-button
          >
          <el-button @click="resetForm('goodsForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <uploadImgComponent
      :isshow_uploadDialog="isshow_uploadDialog"
      @onClose="close_uploadDialog"
      @getChoose_ImgUrl="getChoose_ImgUrl"
      ref="childRef"
      :ImgLimits="ImgLimits"
      :uploadName="uploadName"
    ></uploadImgComponent>
    <el-dialog class="dialog-selgoods" title="选择商品" :visible.sync="dialogGoodsSel">
      <div class="content-page">
        <div class="bd">
          <div class="tab-header">
            <div class="header-right">
              <el-input
                placeholder="请输入商品..."
                v-model.trim="searchInput"
                class="input-search"
                size="small"
                @keyup.enter.native="searchGoods"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="searchGoods"
                ></el-button>
              </el-input>
            </div>
          </div>
          <div class="tab-content">
            <div class="goods-classify-wrap">
              <ol class="goods-classify-list">
                <li
                  v-for="item in classifyOptions"
                  :key="item.goodsCategoryId"
                  :class="isPrimaryCategoryActive(item) ? 'active' : ''"
                  @click="menuSelAction(item)"
                >
                  {{ item.categoryName }}
                </li>
              </ol>
              <ol
                class="goods-classify-list secondary"
                v-if="showSecondaryCategoryPanel"
                v-loading="secondaryCategoryLoading"
              >
                <li
                  v-for="item in secondaryMenuList"
                  :key="item.goodsCategoryId"
                  :class="menuSel == item.goodsCategoryId ? 'active' : ''"
                  @click="secondaryMenuSelAction(item)"
                >
                  {{ item.categoryName }}
                </li>
              </ol>
            </div>
            <div class="goods-list" v-loading="isLoad">
              <div class="list-title">
                <div class="title">商品</div>
                <div class="title">规格</div>
              </div>
              <el-checkbox-group v-model="checkedGoodsList" @change="checkedGoodsChange">
                <el-table :data="goodsList" style="width: 100%" :show-header="false">
                  <el-table-column width="400">
                    <template slot-scope="scope">
                      <el-checkbox
                        :indeterminate="
                          scope.row.products.length > 0 &&
                          scope.row.productsCheck != 0 &&
                          !isNaN(scope.row.productsCheck)
                            ? scope.row.products.length != scope.row.productsCheck
                            : false
                        "
                        :label="scope.row.goodsId"
                        :disabled="
                          scope.row.products.length > 0 || scope.row.unitType == 2
                        "
                        @click.native="
                          scope.row.products.length > 0 || scope.row.unitType == 2
                            ? selGoodsProducts(scope.row.products, scope.$index)
                            : ''
                        "
                      >
                        <div class="goods-info">
                          <el-image
                            class="pic"
                            :src="scope.row.goodsImage || defaultImg"
                            fit="fill"
                            :class="{
                              'lower-shelf': !scope.row.saleStatus,
                              'will-sell-out':
                                scope.row.totalStockCount > 1 &&
                                scope.row.totalStockCount <= 10 &&
                                scope.row.saleStatus,
                              'sell-out':
                                scope.row.totalStockCount <= 0 && scope.row.saleStatus,
                            }"
                          ></el-image>
                          <div class="info">
                            <div class="title">
                              {{ scope.row.goodsName }}
                              <div class="tag-list">
                                <span v-if="scope.row.unitType == 2">计重</span>
                              </div>
                            </div>
                            <p class="price">￥{{ scope.row.retailPrice }}</p>
                          </div>
                        </div>
                      </el-checkbox>
                    </template>
                  </el-table-column>
                  <el-table-column>
                    <template slot-scope="scope">
                      <div v-show="scope.row.productsCheck">
                        已选（{{ scope.row.productsCheck }}）
                      </div>
                      <el-link
                        v-if="scope.row.products.length > 0"
                        type="primary"
                        :underline="false"
                        @click="selGoodsProducts(scope.row.products, scope.$index)"
                        >选择</el-link
                      >
                      <span v-else>-</span>
                    </template>
                  </el-table-column>
                </el-table>
              </el-checkbox-group>
              <div class="list-footer">
                <el-checkbox
                  :indeterminate="isIndeterminate"
                  v-model="allChecked"
                  label="全选"
                  border
                  @change="checkAllChange"
                  size="small"
                  :disabled="totalPage <= 0"
                ></el-checkbox>
                <el-pagination
                  @current-change="handleCurrentChange"
                  :page-size="pageSize"
                  :current-page="pageNo"
                  background
                  layout="prev, pager, next, jumper"
                  :total="totalPage"
                ></el-pagination>
              </div>
            </div>
          </div>
          <div class="tab-footer">
            <span>已选商品：{{ totalCombinedNum }}</span>
            <el-button type="primary" @click="selGoodsConfrim">确定</el-button>
          </div>
        </div>
      </div>
      <el-dialog
        class="dialog-selproducts"
        width="600px"
        title="选择规格"
        :visible.sync="dialogSelProducts"
        append-to-body
      >
        <div class="content-page">
          <div class="tab-content">
            <div class="products-list">
              <div class="list-title">
                <div class="title">规格</div>
                <div class="title">价格</div>
              </div>
              <el-checkbox-group
                v-model="checkProductsList"
                @change="checkProductsChange"
              >
                <el-table :data="productsList" style="width: 100%" :show-header="false">
                  <el-table-column>
                    <template slot-scope="scope">
                      <el-checkbox :label="scope.row.productId">
                        <div class="goods-info">
                          <div class="info">
                            <div class="title">
                              {{ scope.row.valueContent }}
                            </div>
                          </div>
                        </div>
                      </el-checkbox>
                    </template>
                  </el-table-column>
                  <el-table-column>
                    <template slot-scope="scope">
                      {{ scope.row.retailPrice }}
                    </template>
                  </el-table-column>
                </el-table>
              </el-checkbox-group>
              <div class="list-footer">
                <el-checkbox
                  :indeterminate="isProductsIndeterminate"
                  v-model="allProductsChecked"
                  label="全选"
                  border
                  @change="checkAllProductsChange"
                  size="small"
                ></el-checkbox>
                <div>
                  <span>已选规格： {{ checkProductsList.length }}</span>
                  <el-button type="primary" @click="selProductsConfirm">确定</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import {
  uploadImg,
  getEdcShopGoodsCategorys,
  updateGoods,
  getGoodsAllInfo,
  getFindAllGoodsPlus,
  findGoodsNum,
  getGoodsUnitList,
} from "@/api";
import { formatGoodsCategoryListForUI } from "@/utils/goodsCategory";
import {
  getCategoryIdFromCascader,
  getSecondaryCategoryList,
  loadSecondaryCategoryForCascader,
  toCategoryCascaderOptions,
  isSecondaryCategorySwitchOn,
} from "@/utils/secondaryCategory";
import { mapState } from "vuex";

import uploadImgComponent from "@/components/uploadImg";

let goodsListOptions = [];
let productsListOptions = [];
let beforeChangeList = [];
import { commonFuc } from "@/mixins/commonFuc";

export default {
  mixins: [commonFuc],
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      fileList: [],
      goodsImages: [],
      goodsDescriptionImages1: [],
      goodsForm: {
        goodsId: "",
        goodsName: "",
        goodsCategoryId: "",
        goodsDescription: "",
        goodsBarCode: "",
        unitType: 1,
        goodsType: 1,
        goodsImage: "",
        goodsImages: "",
        goodsDescriptionImages: "",
        unit: "",
        goodsUnitId: "",
        baseSales: 0,
        isRequired: 0,
        isPromote: 0,
        isCanDiscount: 0,
        minBuyNum: 1,
        isCanSaleOffline: 0,
        isSingleNoDelivery: 0,
        isFictitious: 0,
        saleAreaType: 0,
        refundNoAuth: 0,
        isOversold: 0,
        tags: "",
        goodsLabel: [],
        groupIds: [],
        products: [
          {
            productId: "",
            retailPrice: "0.00",
            foodBoxPrice: "0.00",
            memberPrice: "0.00",
            barCode: "",
            stockType: "custom",
            stockCount: 1000,
            valueContent: "",
            costPrice: "0.00",
            takePrice: "0.00",
            goodsUnitId: "",
          },
        ],
        productDetail: [],
        freeSpecs: [
          {
            name: "",
            value: [],
            specValueList: [],
            attrValueInputVisible: false,
            attrValueInputValue: "",
          },
        ],
      },
      rules: {
        goodsImage: [
          {
            required: true,
            message: "请至少上传一张图片",
            trigger: "blur",
          },
        ],
        goodsImages: [
          {
            required: true,
            message: "请至少上传一张图片",
            trigger: "blur",
          },
        ],
        goodsDescriptionImages: [
          {
            required: true,
            message: "请至少上传一张图片",
            trigger: "blur",
          },
        ],
        goodsName: [
          {
            required: true,
            message: "请填写商品名称",
            trigger: "blur",
          },
        ],
        // goodsDescription: [
        //     {
        //         required: true,
        //         message: "请填写商品描述",
        //         trigger: "blur"
        //     }
        // ],
        unit: [
          {
            required: true,
            message: "请填写商品单位",
            trigger: "blur",
          },
        ],
        goodsUnitId: [
          {
            required: false,
            message: "请选择商品单位",
            trigger: "blur",
          },
        ],
      },
      classifyOptions: [],
      classifyOptionsNoGroup: [],
      secondaryMenuList: [],
      secondaryMenuParentId: "",
      secondaryCategoryCache: {},
      secondaryCategoryPendingMap: {},
      secondaryCategoryLoading: false,
      secondaryCategoryRequestKey: 0,
      activePrimaryCategoryId: "",
      categoryCascaderOptions: [],
      goodsCategoryCascaderValue: [],
      groupOptions: [],
      isAddGoodsSpec: false,
      isSubmit: false,
      hideUpload: false,
      isshow_uploadDialog: false,
      dialogGoodsSel: false,
      dialogSelProducts: false,
      goodsList: [],
      menuSel: "",
      searchInput: "",
      statusValue: "all",
      isLoad: false,
      allChecked: false,
      isIndeterminate: false,
      isSel: false,
      checkedGoodsList: [],
      totalPage: 0,
      pageSize: 10,
      pageNo: 1,
      dialogSelProducts: false,
      checkProductsList: [],
      productsList: [],
      selGoodsIndex: 0,
      isProductsIndeterminate: false,
      allProductsChecked: false,
      selProductsObj: {},
      goodsHistory: {},
      totalCombinedNum: 0,
      defaultImg: require("../assets/img/common/default-img.jpg"),
      ImgLimits: 0,
      uploadName: "",
      isRecommend: 0,
      uploadDisabled: false,
      goodsUnitList: [],
      currentGroupIndex: 0,
    };
  },
  components: {
    uploadImgComponent,
  },
  computed: {
    ...mapState({
      shopInfo: (state) => state.shopInfo,
    }),
    showSecondaryCategoryPanel() {
      return this.secondaryCategoryLoading || this.secondaryMenuList.length > 0;
    },
    isShowCanSaleOfflineAndCountRelated() {
      return (
        this.goodsForm.isCanSaleOffline == 1 &&
        this.goodsForm.unitType == 1 &&
        this.shopInfo.edcShopType == 4
      );
    },
    isShowCanSaleOfflineRelated() {
      return this.goodsForm.isCanSaleOffline == 1 && this.shopInfo.edcShopType == 4;
    },
    categoryCascaderProps() {
      return {
        checkStrictly: true,
        emitPath: true,
        lazy: true,
        lazyLoad: this.loadCategoryCascader,
      };
    },
    // totalCombinedNum() {
    //   console.log("totalCombinedNum");
    //   let count = 0;
    //   this.checkedGoodsList.forEach((val) => {
    //     let productsObj = this.selProductsObj[val];
    //     if (productsObj && productsObj.length) {
    //       productsObj.forEach((pval) => {
    //         count++;
    //       });
    //     } else {
    //       count++;
    //     }
    //   });
    //   return count;
    // },
  },
  watch: {
    checkedGoodsList() {
      let count = 0;
      this.checkedGoodsList.forEach((val) => {
        let productsObj = this.selProductsObj[val];
        if (productsObj && productsObj.length) {
          productsObj.forEach((pval) => {
            count++;
          });
        } else {
          count++;
        }
      });
      this.totalCombinedNum = count;
    },
    isShowCanSaleOfflineAndCountRelated(val) {
      if (val) {
        this.rules.goodsUnitId[0].required = true;
        this.rules.unit[0].required = false;
      } else {
        this.rules.goodsUnitId[0].required = false;
        this.rules.unit[0].required = true;
      }
    },
    // selProductsObj: {
    //   deep: true,
    //   handler: function() {
    //     let count = 0;
    //     this.checkedGoodsList.forEach((val) => {
    //       let productsObj = this.selProductsObj[val];
    //       if (productsObj && productsObj.length) {
    //         productsObj.forEach((pval) => {
    //           count++;
    //         });
    //       } else {
    //         count++;
    //       }
    //     });
    //     this.totalCombinedNum = count;
    //   },
    // },
  },
  mounted() {
    if (
      (this.isDsType ||
        this.shopInfo.edcShopType == 5 ||
        this.shopInfo.edcShopType == 8) &&
      this.$route.path == "/goods/edit"
    ) {
      this.$router.replace({
        path: "/goods/dsedit",
        query: this.$route.query,
      });
    }
    this.getPageData();
  },
  methods: {
    getGoodsCategoryCascaderValue(goods = {}, goodsCategory = {}) {
      const goodsCategoryId = goods.goodsCategoryId;
      if (!goodsCategoryId) {
        return [];
      }
      const parentId = goodsCategory.parentId;
      if (parentId && parentId != goodsCategoryId) {
        return [parentId, goodsCategoryId];
      }
      return [goodsCategoryId];
    },
    async syncGoodsCategoryCascaderValue(goods = {}, goodsCategory = {}) {
      const cascaderValue = this.getGoodsCategoryCascaderValue(goods, goodsCategory);
      if (cascaderValue.length !== 2) {
        this.goodsCategoryCascaderValue = cascaderValue;
        return;
      }
      const [parentId, goodsCategoryId] = cascaderValue.map((item) => `${item}`);
      const parentOption = this.categoryCascaderOptions.find((item) => {
        return `${item.value}` == parentId;
      });
      if (!parentOption) {
        this.goodsCategoryCascaderValue = [goods.goodsCategoryId];
        return;
      }
      if (!parentOption.children || !parentOption.children.length) {
        const res = await getSecondaryCategoryList(parentId, 1000);
        if (res.code == 1 && res.data && res.data.length) {
          const children = res.data.map((item) => {
            return {
              value: item.goodsCategoryId,
              label: item.categoryName,
              leaf: true,
              raw: item,
            };
          });
          this.$set(parentOption, "children", children);
        }
      }
      const matchedChild =
        parentOption.children &&
        parentOption.children.find((item) => `${item.value}` == goodsCategoryId);
      const normalizedValue = matchedChild
        ? [parentOption.value, matchedChild.value]
        : [goods.goodsCategoryId];
      this.goodsCategoryCascaderValue = [];
      await this.$nextTick();
      this.goodsCategoryCascaderValue = normalizedValue;
    },
    getGoodsUnitList() {
      if (this.goodsUnitList.length) return;
      getGoodsUnitList({
        isEnable: 1,
        unitType: 1,
        pageNo: 1,
        row: 9999,
      }).then((res) => {
        if (res.code == 1) {
          this.goodsUnitList = res.data;
        }
      });
    },
    show_uploadDialog(val, name) {
      this.ImgLimits = val;
      this.uploadName = name;
      this.uploadDisabled = true;
      this.$refs.childRef.rSelect = [];
      this.isshow_uploadDialog = true;
    },
    getChoose_ImgUrl(arr, name) {
      console.log(arr);
      this.isshow_uploadDialog = false;
      this.uploadDisabled = false;
      if (arr.length > 0) {
        arr.forEach((item) => {
          if (name == "goodsImages") {
            if (this.goodsForm.goodsImages.length) {
              this.goodsForm.goodsImages += `,${item.image}`;
            } else {
              this.goodsForm.goodsImages = item.image;
            }
            this.goodsImages.push({ name: "", url: item.image });
            return;
          }
          if (name == "goodsDescriptionImages") {
            if (this.goodsForm.goodsDescriptionImages.length) {
              this.goodsForm.goodsDescriptionImages += `,${item.image}`;
            } else {
              this.goodsForm.goodsDescriptionImages = item.image;
            }
            this.goodsDescriptionImages1.push({ name: "", url: item.image });
            return;
          }
          this.goodsForm.goodsImage = item.image;
          this.fileList = [{ url: this.goodsForm.goodsImage }];
          this.$refs["goodsForm"].validate();
        });
      }
    },
    close_uploadDialog() {
      this.isshow_uploadDialog = false;
    },
    handleEditChange(file, fileList) {
      this.hideUpload = fileList.length >= 1;
    },
    async getPageData() {
      if (this.shopInfo.edcShopType == 4) {
        this.getGoodsUnitList();
      }
      await getEdcShopGoodsCategorys({
        row: 1000,
      }).then((res) => {
        if (res.code == 1) {
          res.data = formatGoodsCategoryListForUI(res.data);
          this.initSecondaryCategoryCache(res.data);
          this.classifyOptions = res.data.filter((item) => Number(item.level) !== 2);
          res.data.forEach((val) => {
            if (val.categoryType == 2) {
              this.groupOptions.push(val);
            } else {
              this.classifyOptionsNoGroup.push(val);
            }
          });
          this.goodsForm.goodsCategoryId = this.classifyOptionsNoGroup[0].goodsCategoryId;
          this.categoryCascaderOptions = toCategoryCascaderOptions(
            this.classifyOptionsNoGroup,
            {
              includeAll: false,
            }
          );
          this.goodsCategoryCascaderValue = [this.goodsForm.goodsCategoryId];
          this.menuSel =
            this.classifyOptions.length > 0
              ? this.classifyOptions[0].goodsCategoryId
              : "";
          this.activePrimaryCategoryId = this.menuSel;
          if (this.classifyOptions.length > 0 && isSecondaryCategorySwitchOn()) {
            this.fetchSecondaryCategoryList(this.classifyOptions[0], {
              showInPanel: true,
            });
          }
        }
      });
      if (this.$route.query.goodsId) {
        this.goodsForm.goodsId = this.$route.query.goodsId;
        const res = await getGoodsAllInfo({
          goodsId: this.goodsForm.goodsId,
        });
        if (res.code == 1) {
          let goodsForm = {
            goodsId: res.data.good.goodsId,
            goodsName: res.data.good.goodsName,
            goodsCategoryId: res.data.good.goodsCategoryId,
            goodsDescription: res.data.good.goodsDescription,
            goodsBarCode: res.data.good.goodsBarCode,
            unitType: res.data.good.unitType || 1,
            goodsType: res.data.good.goodsType || 1,
            goodsImage: res.data.good.goodsImage,
            goodsImages: res.data.good.goodsImages || "",
            goodsDescriptionImages: res.data.good.goodsDescriptionImages || "",
            unit: res.data.good.unit,
            goodsUnitId: res.data.good.goodsUnitId,
            baseSales: res.data.good.baseSales || 0,
            isRequired: res.data.good.isRequired,
            isPromote: res.data.good.isPromote,
            isCanDiscount: res.data.good.isCanDiscount || 0,
            minBuyNum: res.data.good.minBuyNum || 0,
            isSingleNoDelivery: res.data.good.isSingleNoDelivery || 0,
            isFictitious: res.data.good.isFictitious || 0,
            saleAreaType: res.data.good.saleAreaType || 0,
            refundNoAuth: res.data.good.refundNoAuth || 0,
            isRecommend: res.data.good.isRecommend || 0,
            tags: res.data.good.tags,
            goodsLabel: res.data.good.tags ? res.data.good.tags.split(",") : [],
            groupIds: res.data.good.groupIds ? [res.data.good.groupIds] : [],
            productDetail: [],
            products: [],
            freeSpecs: [],
            isCanSaleOffline: res.data.good.isCanSaleOffline || 0,
          };
          let parsedDetail = res.data.good.productDetail
            ? JSON.parse(res.data.good.productDetail)
            : [];
          if (parsedDetail.length > 0 && !parsedDetail[0].hasOwnProperty("groupName")) {
            let mappedItems = parsedDetail.map((item) => {
              item.comboCount = item.buyCount || 1;
              return item;
            });
            parsedDetail = [
              {
                groupName: "默认分组",
                isRepeatable: 0,
                minSelect: 1,
                maxSelect: mappedItems.reduce(
                  (sum, item) => sum + (item.comboCount || 1),
                  0
                ),
                items: mappedItems,
              },
            ];
          }
          goodsForm.productDetail = parsedDetail;
          if (res.data.freeSpecs && res.data.freeSpecs.length) {
            res.data.freeSpecs.forEach((val) => {
              let data = {
                name: val.name,
                value: [],
                specValueList: val.specValueList,
                attrValueInputVisible: false,
                attrValueInputValue: "",
              };
              if (val.specValueList.length) {
                val.specValueList.forEach((subval) => {
                  data.value.push(subval.value);
                });
              }
              goodsForm.freeSpecs.push(data);
            });
          } else {
            goodsForm.freeSpecs = [
              {
                name: "",
                value: [],
                specValueList: [],
                attrValueInputVisible: false,
                attrValueInputValue: "",
              },
            ];
          }
          console.log(res.data.products, res.data.products.length);
          if (res.data.products && res.data.products.length) {
            this.isAddGoodsSpec = true;
            res.data.products.forEach((val) => {
              let data = {
                goodsId: val.goodsId,
                productId: val.productId,
                retailPrice: val.retailPrice,
                foodBoxPrice: val.foodBoxPrice,
                memberPrice: val.memberPrice,
                barCode: val.barCode,
                stockType: "custom",
                stockCount: val.stockCount,
                valueContent: val.valueContent,
                costPrice: val.costPrice,
                takePrice: val.takePrice,
                goodsUnitId: val.goodsUnitId,
              };
              goodsForm.products.push(data);
            });
          } else {
            goodsForm.products = [
              {
                goodsId: res.data.good.goodsId,
                productId: "",
                retailPrice: res.data.good.retailPrice,
                foodBoxPrice: res.data.good.foodBoxPrice,
                memberPrice: res.data.good.memberPrice,
                barCode: res.data.good.barCode,
                stockType: "custom",
                stockCount: res.data.good.totalStockCount,
                valueContent: "",
                costPrice: res.data.good.retailPrice,
                takePrice: res.data.good.retailPrice,
                goodsUnitId: "",
              },
            ];
          }
          let goodsImages = goodsForm.goodsImages ? goodsForm.goodsImages.split(",") : [];
          if (goodsImages.length && goodsImages[0].length) {
            goodsImages.forEach((val) => {
              this.goodsImages.push({
                name: val,
                url: val,
              });
            });
          }
          let goodsDescriptionImages = goodsForm.goodsDescriptionImages
            ? goodsForm.goodsDescriptionImages.split(",")
            : [];
          if (goodsDescriptionImages.length && goodsDescriptionImages[0].length) {
            goodsDescriptionImages.forEach((val) => {
              this.goodsDescriptionImages1.push({
                name: val,
                url: val,
              });
            });
          }
          if (res.data.good.goodsImage) {
            this.fileList = [{ url: res.data.good.goodsImage }];
          } else {
            this.fileList = [];
          }
          this.goodsForm = goodsForm;
          await this.syncGoodsCategoryCascaderValue(
            res.data.good,
            res.data.goodsCategory
          );
        }
      }
    },
    loadCategoryCascader(node, resolve) {
      loadSecondaryCategoryForCascader(node, resolve, 1000);
    },
    handleGoodsCategoryChange(value) {
      this.goodsForm.goodsCategoryId = getCategoryIdFromCascader(value);
    },
    selGoods(gIndex) {
      this.currentGroupIndex = gIndex;
      let items = this.goodsForm.productDetail[gIndex].items;
      this.checkedGoodsList = [];
      this.selProductsObj = {};
      if (items && items.length) {
        items.forEach((val) => {
          if (this.checkedGoodsList.indexOf(val.goodsId) == -1) {
            this.checkedGoodsList.push(val.goodsId);
          }
          if (!this.selProductsObj[val.goodsId]) {
            this.selProductsObj[val.goodsId] = [];
          }
          if (
            this.selProductsObj[val.goodsId] &&
            this.selProductsObj[val.goodsId].indexOf(val.productId) == -1 &&
            val.productId
          ) {
            this.selProductsObj[val.goodsId].push(val.productId);
          }
        });
      }
      this.getNextData();
      this.dialogGoodsSel = true;
    },
    getGoodsList() {
      this.isLoad = true;
      getFindAllGoodsPlus({
        saleStatus: 1,
        goodsCategoryId: this.menuSel == "hot" ? "" : this.menuSel,
        pageNo: this.pageNo,
        row: this.pageSize,
        goodsName: this.searchInput,
        goodsType: 1,
      }).then((res) => {
        if (res.code == 1) {
          goodsListOptions = [];
          res.data.forEach((val) => {
            val.visible = false;
            this.tagsChange = this.menuSel;
            val.tagsChange = this.menuSel;
            goodsListOptions.push(val.goodsId);
            console.log(this.selProductsObj);
            val.productsCheck =
              this.selProductsObj[val.goodsId] && this.selProductsObj[val.goodsId].length;
            this.goodsHistory[val.goodsId] = val;
          });
          res.data = res.data.filter((val) => {
            return val.goodsId != this.goodsForm.goodsId;
          });
          this.goodsList = res.data;
          let checkedCount = res.data.filter((val) => {
            return this.checkedGoodsList.indexOf(val.goodsId) > -1;
          }).length;
          this.allChecked = checkedCount === this.goodsList.length;
          this.isIndeterminate = checkedCount > 0 && checkedCount < this.goodsList.length;
        }
        if (res.code == -1) {
          this.goodsList = [];
        }
        this.isLoad = false;
      });
    },
    findGoodsNum() {
      findGoodsNum({
        saleStatus: 1,
        goodsCategoryId: this.menuSel == "hot" ? "" : this.menuSel,
        goodsName: this.searchInput,
        goodsType: 1,
      }).then((res) => {
        if (res.code == 1) {
          this.totalPage = res.data;
          if (this.pageNo > this.totalPage / this.pageSize) {
            this.pageNo = Math.ceil(this.totalPage / this.pageSize);
          }
        }
      });
    },
    initSecondaryCategoryCache(categoryList = []) {
      const cache = Object.assign({}, this.secondaryCategoryCache);
      const nextCache = {};
      (categoryList || []).forEach((item) => {
        if (Number(item.level) !== 2 || !item.parentId) {
          return;
        }
        const parentId = `${item.parentId}`;
        if (!nextCache[parentId]) {
          nextCache[parentId] = [];
        }
        nextCache[parentId].push({
          ...item,
          rawCategoryName: item.rawCategoryName || item.categoryName,
        });
      });
      Object.keys(nextCache).forEach((parentId) => {
        cache[parentId] = nextCache[parentId];
      });
      this.secondaryCategoryCache = cache;
    },
    resetSecondaryCategoryPanel() {
      this.secondaryCategoryRequestKey += 1;
      this.secondaryCategoryLoading = false;
      this.secondaryMenuList = [];
      this.secondaryMenuParentId = "";
    },
    applySecondaryCategoryPanel(parentId, list = []) {
      const nextList = Array.isArray(list) ? list.slice() : [];
      this.secondaryCategoryLoading = false;
      this.secondaryMenuList = nextList;
      this.secondaryMenuParentId = nextList.length ? `${parentId}` : "";
    },
    async fetchSecondaryCategoryList(parentItem, options = {}) {
      const { showInPanel = false } = options;
      if (!parentItem || !parentItem.goodsCategoryId || !isSecondaryCategorySwitchOn()) {
        if (showInPanel) {
          this.resetSecondaryCategoryPanel();
        }
        return [];
      }
      const parentId = `${parentItem.goodsCategoryId}`;
      if (Object.prototype.hasOwnProperty.call(this.secondaryCategoryCache, parentId)) {
        const cachedList = this.secondaryCategoryCache[parentId] || [];
        if (showInPanel) {
          this.applySecondaryCategoryPanel(parentId, cachedList);
        }
        return cachedList;
      }
      let requestKey = this.secondaryCategoryRequestKey;
      if (showInPanel) {
        requestKey = this.secondaryCategoryRequestKey + 1;
        this.secondaryCategoryRequestKey = requestKey;
        this.secondaryCategoryLoading = true;
        this.secondaryMenuParentId = parentId;
        this.secondaryMenuList = [];
      }
      if (!this.secondaryCategoryPendingMap[parentId]) {
        this.secondaryCategoryPendingMap[parentId] = getSecondaryCategoryList(
          parentItem.goodsCategoryId,
          1000
        )
          .then((res) => {
            const nextList =
              res.code == 1 && Array.isArray(res.data)
                ? res.data.map((item) => {
                    return {
                      ...item,
                      parentId: item.parentId || parentItem.goodsCategoryId,
                      rawCategoryName: item.rawCategoryName || item.categoryName,
                    };
                  })
                : [];
            this.$set(this.secondaryCategoryCache, parentId, nextList);
            return nextList;
          })
          .finally(() => {
            delete this.secondaryCategoryPendingMap[parentId];
          });
      }
      const nextList = await this.secondaryCategoryPendingMap[parentId];
      if (showInPanel && requestKey === this.secondaryCategoryRequestKey) {
        this.applySecondaryCategoryPanel(parentId, nextList);
      }
      return nextList;
    },
    syncMenuSelection(id, options = {}) {
      const { primaryId = "", keepSecondaryPanel = false } = options;
      if (!keepSecondaryPanel) {
        this.resetSecondaryCategoryPanel();
      }
      this.menuSel = id;
      this.activePrimaryCategoryId = primaryId;
      this.pageNo = 1;
      this.searchInput = "";
      this.statusValue = "all";
      this.getNextData();
    },
    isPrimaryCategoryActive(item) {
      if (!item) {
        return false;
      }
      return `${item.goodsCategoryId}` == `${this.activePrimaryCategoryId}`;
    },
    menuSelAction(item) {
      if (!item || !item.goodsCategoryId) {
        return;
      }
      const id = item.goodsCategoryId;
      const samePrimarySelected =
        `${this.menuSel}` == `${id}` && `${this.activePrimaryCategoryId}` == `${id}`;
      if (
        samePrimarySelected &&
        (!isSecondaryCategorySwitchOn() ||
          Object.prototype.hasOwnProperty.call(this.secondaryCategoryCache, `${id}`))
      ) {
        return;
      }
      if (isSecondaryCategorySwitchOn()) {
        this.resetSecondaryCategoryPanel();
      }
      this.syncMenuSelection(id, {
        primaryId: id,
        keepSecondaryPanel: isSecondaryCategorySwitchOn(),
      });
      if (!isSecondaryCategorySwitchOn()) {
        return;
      }
      this.fetchSecondaryCategoryList(item, {
        showInPanel: true,
      });
    },
    secondaryMenuSelAction(item) {
      if (!item || !item.goodsCategoryId) {
        return;
      }
      const parentId = item.parentId || this.activePrimaryCategoryId;
      if (
        `${this.menuSel}` == `${item.goodsCategoryId}` &&
        `${this.activePrimaryCategoryId}` == `${parentId}`
      ) {
        return;
      }
      this.syncMenuSelection(item.goodsCategoryId, {
        primaryId: parentId,
        keepSecondaryPanel: true,
      });
    },
    searchGoods() {
      this.pageNo = 1;
      this.getNextData();
    },
    getNextData() {
      this.getGoodsList();
      this.findGoodsNum();
    },
    handleCurrentChange(val) {
      console.log("handleCurrentChange", val);
      this.pageNo = val;
      this.getNextData();
    },
    checkedGoodsChange(value) {
      console.log(value);
      let checkedCount = value.length;
      this.allChecked = checkedCount === this.goodsList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.goodsList.length;
      this.isSel = checkedCount > 0;
    },
    checkAllChange(val) {
      beforeChangeList = JSON.parse(JSON.stringify(this.checkedGoodsList));
      let mergeAddGoodsList = goodsListOptions.filter((val) => {
        return (
          beforeChangeList.indexOf(val) == -1 && this.goodsHistory[val].unitType != 2
        );
      });
      let mergeReduceGoodsList = beforeChangeList.filter((val) => {
        return goodsListOptions.indexOf(val) == -1;
      });
      console.log(beforeChangeList, mergeAddGoodsList);
      this.checkedGoodsList = val
        ? [...beforeChangeList, ...mergeAddGoodsList]
        : mergeReduceGoodsList;
      this.goodsList.forEach((gval, index) => {
        if (gval.products.length && gval.unitType != 2) {
          gval.products.forEach((pval) => {
            pval.isSel = val;
            if (!this.selProductsObj[gval.goodsId]) {
              this.selProductsObj[gval.goodsId] = [];
            }
            if (this.selProductsObj[gval.goodsId].indexOf(pval.productId) == -1) {
              this.selProductsObj[gval.goodsId].push(pval.productId);
            }
          });
          if (val) {
            this.$set(this.goodsList[index], "productsCheck", gval.products.length);
          } else {
            this.$set(this.goodsList[index], "productsCheck", 0);
            this.selProductsObj[gval.goodsId] = [];
          }
        }
      });
      this.isIndeterminate = false;
      this.isSel = val;
      this.allChecked = val;
      beforeChangeList = [];
    },
    selGoodsConfrim() {
      let gIndex = this.currentGroupIndex;
      let items = [];
      let currentItems = this.goodsForm.productDetail[gIndex].items || [];
      this.checkedGoodsList.forEach((val) => {
        let goods = this.goodsHistory[val];
        if (goods) {
          if (!goods.products || goods.products.length == 0) {
            let currentGoods = currentItems.filter(
              (cval) => cval.goodsId == goods.goodsId
            );
            if (!currentGoods.length) {
              items.push({
                goodsName: goods.goodsName,
                goodsCategoryId: goods.goodsCategoryId,
                goodsUnit: goods.unit,
                comboCount: 1,
                subTotal: 1 * goods.retailPrice,
                retailPrice: goods.retailPrice,
                goodsId: goods.goodsId,
                productId: "",
              });
            } else {
              items.push({
                goodsName: goods.goodsName,
                goodsCategoryId: goods.goodsCategoryId,
                goodsUnit: goods.unit,
                comboCount: currentGoods[0].comboCount || currentGoods[0].buyCount || 1,
                subTotal:
                  (currentGoods[0].comboCount || currentGoods[0].buyCount || 1) *
                  goods.retailPrice,
                retailPrice: goods.retailPrice,
                goodsId: goods.goodsId,
                productId: "",
              });
            }
          } else {
            this.selProductsObj[val].forEach((pval) => {
              goods.products.forEach((spval) => {
                if (pval == spval.productId) {
                  let currentGoods = currentItems.filter(
                    (cval) =>
                      cval.goodsId == goods.goodsId && cval.productId == spval.productId
                  );
                  if (!currentGoods.length) {
                    items.push({
                      goodsName: goods.goodsName + `(${spval.valueContent})`,
                      goodsCategoryId: goods.goodsCategoryId,
                      goodsUnit: goods.unit,
                      comboCount: 1,
                      subTotal: 1 * spval.retailPrice,
                      retailPrice: spval.retailPrice,
                      goodsId: goods.goodsId,
                      productId: spval.productId,
                    });
                  } else {
                    items.push({
                      goodsName: goods.goodsName + `(${spval.valueContent})`,
                      goodsCategoryId: goods.goodsCategoryId,
                      goodsUnit: goods.unit,
                      comboCount:
                        currentGoods[0].comboCount || currentGoods[0].buyCount || 1,
                      subTotal:
                        (currentGoods[0].comboCount || currentGoods[0].buyCount || 1) *
                        spval.retailPrice,
                      retailPrice: spval.retailPrice,
                      goodsId: goods.goodsId,
                      productId: spval.productId,
                    });
                  }
                }
              });
            });
          }
        } else {
          currentItems.forEach((dval) => {
            if (dval.goodsId == val) {
              let comboCount = dval.comboCount || dval.buyCount || 1;
              items.push({
                goodsName: dval.goodsName,
                goodsCategoryId: dval.goodsCategoryId,
                goodsUnit: dval.goodsUnit,
                comboCount: comboCount,
                subTotal: dval.subTotal || comboCount * dval.retailPrice,
                retailPrice: dval.retailPrice,
                goodsId: dval.goodsId,
                productId: dval.productId,
              });
            }
          });
        }
      });
      console.log(items);
      this.goodsForm.productDetail[gIndex].items = items;
      let N = items.reduce((sum, item) => sum + (item.comboCount || 1), 0);
      this.goodsForm.productDetail[gIndex].maxSelect = N;
      if (this.goodsForm.productDetail[gIndex].minSelect > N) {
        this.goodsForm.productDetail[gIndex].minSelect = N || 1;
      }
      // 强制刷新 minSelect 的显示文本
      let currentMinSelect = this.goodsForm.productDetail[gIndex].minSelect;
      this.goodsForm.productDetail[gIndex].minSelect = null;
      this.$nextTick(() => {
        this.goodsForm.productDetail[gIndex].minSelect = currentMinSelect;
      });
      this.dialogGoodsSel = false;
    },
    selGoodsProducts(val, index) {
      if (this.goodsList[index].unitType == 2) {
        return this.$notify({
          title: "提示",
          message: "计重商品不能加入组合商品",
          type: "error",
          duration: 1000,
        });
      }
      this.checkProductsList = [];
      this.selGoodsIndex = 0;
      this.isProductsIndeterminate = false;
      this.allProductsChecked = false;

      this.dialogSelProducts = true;
      productsListOptions = [];
      console.log(this.selProductsObj[this.goodsList[index].goodsId]);
      val.forEach((pval) => {
        productsListOptions.push(pval.productId);
        if (
          this.selProductsObj[this.goodsList[index].goodsId] &&
          this.selProductsObj[this.goodsList[index].goodsId].indexOf(pval.productId) > -1
        ) {
          this.checkProductsList.push(pval.productId);
        }
      });
      let checkedCount = this.checkProductsList.length;
      this.allProductsChecked = checkedCount === val.length;
      this.isProductsIndeterminate = checkedCount > 0 && checkedCount < val.length;
      console.log(productsListOptions);
      this.productsList = val;
      this.selGoodsIndex = index;
    },
    checkProductsChange(value) {
      let checkedCount = value.length;
      this.allProductsChecked = checkedCount === this.productsList.length;
      this.isProductsIndeterminate =
        checkedCount > 0 && checkedCount < this.productsList.length;
      this.isSel = checkedCount > 0;
    },
    checkAllProductsChange(val) {
      this.checkProductsList = val ? productsListOptions : [];
      this.isProductsIndeterminate = false;
      this.allProductsChecked = val;
    },
    selProductsConfirm() {
      let checkedCount = 0;
      this.goodsList[this.selGoodsIndex].products.forEach((pval) => {
        pval.isSel = false;
      });
      console.log(this.checkProductsList, this.checkedGoodsList);
      this.checkProductsList.forEach((val) => {
        this.goodsList[this.selGoodsIndex].products.forEach((pval) => {
          if (val == pval.productId) {
            pval.isSel = true;
            checkedCount++;
          }
        });
      });
      this.$set(this.goodsList[this.selGoodsIndex], "productsCheck", checkedCount);
      if (checkedCount) {
        if (
          this.checkedGoodsList.indexOf(this.goodsList[this.selGoodsIndex].goodsId) == -1
        ) {
          this.checkedGoodsList.push(this.goodsList[this.selGoodsIndex].goodsId);
        }
      } else {
        if (
          this.checkedGoodsList.indexOf(this.goodsList[this.selGoodsIndex].goodsId) >
            -1 &&
          !this.checkProductsList.length
        ) {
          this.checkedGoodsList.splice(
            this.checkedGoodsList.indexOf(this.goodsList[this.selGoodsIndex].goodsId),
            1
          );
        }
      }
      this.$set(
        this.selProductsObj,
        this.goodsList[this.selGoodsIndex].goodsId,
        this.checkProductsList
      );
      // this.selProductsObj[
      //   this.goodsList[this.selGoodsIndex].goodsId
      // ] = this.checkProductsList;
      this.$forceUpdate();
      let count = 0;
      this.checkedGoodsList.forEach((val) => {
        let productsObj = this.selProductsObj[val];
        if (productsObj && productsObj.length) {
          productsObj.forEach((pval) => {
            count++;
          });
        } else {
          count++;
        }
      });
      this.totalCombinedNum = count;
      this.dialogSelProducts = false;
    },
    delProductDetail(gIndex, index) {
      this.goodsForm.productDetail[gIndex].items.splice(index, 1);
      let N = this.goodsForm.productDetail[gIndex].items.reduce(
        (sum, item) => sum + (item.comboCount || 1),
        0
      );
      this.goodsForm.productDetail[gIndex].maxSelect = N;
      if (this.goodsForm.productDetail[gIndex].minSelect > N) {
        this.goodsForm.productDetail[gIndex].minSelect = N || 1;
      }
      // 强制刷新 minSelect 的显示文本，解决 el-select 在 value 不变时不更新 label 的问题
      let currentMinSelect = this.goodsForm.productDetail[gIndex].minSelect;
      this.goodsForm.productDetail[gIndex].minSelect = null;
      this.$nextTick(() => {
        this.goodsForm.productDetail[gIndex].minSelect = currentMinSelect;
      });
    },
    getGroupTotalComboCount(group) {
      if (!group || !group.items) return 0;
      return group.items.length;
    },
    addGroup() {
      this.goodsForm.productDetail.push({
        groupName: "新分组",
        isRepeatable: 0,
        minSelect: 1,
        maxSelect: 0,
        items: [],
      });
    },
    delGroup(gIndex) {
      this.goodsForm.productDetail.splice(gIndex, 1);
    },
    handleRemove(file, name) {
      if (name == "goodsImages") {
        let goodsImages = this.goodsForm.goodsImages.split(",");
        let goodsImages1 = this.goodsForm.goodsImages.split(",");
        // console.log(goodsImages.length, goodsImages, "删除前的goodsImages");
        goodsImages.splice(goodsImages.indexOf(file.url), 1);
        // console.log(goodsImages, "删除后的goodsImages");
        this.goodsForm.goodsImages = "";
        this.goodsForm.goodsImages = goodsImages.join(",");
        // console.log(goodsImages, "goodsImages")
        // console.log(this.goodsForm.goodsImages, "this.goodsForm.goodsImages")
        // console.log(this.goodsImages, "删除前的this.goodsImages")
        this.goodsImages.splice(goodsImages1.indexOf(file.url), 1);
        // console.log(this.goodsImages, "删除后的this.goodsImages")
      } else if (name == "goodsDescriptionImages") {
        // console.log(11111);
        let goodsDescriptionImages = this.goodsForm.goodsDescriptionImages.split(",");
        let goodsDescriptionImages1 = this.goodsForm.goodsDescriptionImages.split(",");
        // console.log(goodsDescriptionImages.length, "goodsDescriptionImages.length");
        goodsDescriptionImages.splice(goodsDescriptionImages.indexOf(file.name), 1);
        // console.log(file.name, "file.name");
        this.goodsForm.goodsDescriptionImages = goodsDescriptionImages.join(",");
        this.goodsDescriptionImages1.splice(goodsDescriptionImages1.indexOf(file.url), 1);
      } else {
        this.goodsForm[name] = "";
      }
    },
    limitTip(files, fileList) {
      this.$notify({
        title: "警告",
        message: "只能上传一张图片，请删除图片后再上传",
        type: "warning",
        duration: 6000,
      });
    },
    beforeRemove(file, fileList) {},
    beforeImgUpload(file) {
      const isLt3M = file.size / 1024 / 1024 < 3;
      if (!isLt3M) {
        this.$notify.error("上传图片大小不能超过 3MB!");
      }
      return isLt3M;
    },
    handleSuccess(item, name) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", item.file);
      imgUploadForm.append("fileContentType", item.file.type);
      imgUploadForm.append("fileFileName", item.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      uploadImg(imgUploadForm).then((res) => {
        console.log(res);
        if (res.code == 1) {
          if (name == "goodsImages" || name == "goodsDescriptionImages") {
            if (this.goodsForm[name].length) {
              this.goodsForm[name] += `,${res.data.url}`;
            } else {
              this.goodsForm[name] = res.data.url;
            }
            return;
          }
          this.goodsForm[name] = res.data.url;
        }
      });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    submitForm(formName) {
      console.log(formName, this.goodsForm, "this.goodsForm");
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.goodsForm));
          params.tags = params.goodsLabel.join(",");
          params.freeSpecs = [];
          console.log(params, this.goodsForm.products);
          params.groupIds = params.groupIds[0];
          let isNoneValueFreeSpecs = false;
          this.goodsForm.freeSpecs.forEach((val, index) => {
            if (val.name && val.value.length) {
              params.freeSpecs[index] = val;
              params.freeSpecs[index].specValueList = [];
              val.value.forEach((subval) => {
                params.freeSpecs[index].specValueList.push({
                  value: subval,
                });
              });
            } else {
              if (val.name) {
                isNoneValueFreeSpecs = true;
              }
              params.freeSpecs.splice(index, 1);
            }
          });
          if (isNoneValueFreeSpecs) {
            this.$notify({
              title: "提示",
              message: "商品属性值不能为空",
              type: "error",
              duration: 2000,
            });
            return;
          }
          params.freeSpecs = JSON.stringify(params.freeSpecs);
          params.totalStockCount = 0;
          params.products = [];
          params.productDetail = JSON.stringify(params.productDetail);
          this.isSubmit = true;
          if (params.goodsType != 2) {
            this.goodsForm.products.forEach((val, index) => {
              if (val.valueContent) {
                params.products.push({
                  goodsId: this.goodsForm.goodsId,
                  productId: val.productId ? val.productId : "",
                  retailPrice: val.retailPrice,
                  foodBoxPrice: val.foodBoxPrice || 0,
                  memberPrice: val.memberPrice,
                  barCode: val.barCode,
                  costPrice: 0,
                  stockType: "custom",
                  stockCount: val.stockCount,
                  valueContent: val.valueContent,
                  costPrice: val.costPrice,
                  takePrice: val.takePrice,
                  goodsUnitId: val.goodsUnitId,
                });
                params.totalStockCount += Math.abs(parseInt(val.stockCount));
              } else {
                if (this.goodsForm.products.length > 1) {
                  params.products.splice(index, 1);
                } else {
                  params.totalStockCount = Math.abs(parseInt(val.stockCount));
                }
              }
            });
          }
          if (params.goodsType == 2) {
            if (this.shopInfo.edcShopType != 3) {
              return this.$notify({
                title: "提示",
                message: "只有酒店类型可以创建组合商品",
                type: "error",
                duration: 1000,
              });
            }
            params.totalStockCount = this.goodsForm.products[0].stockCount;
          }
          params.retailPrice = this.goodsForm.products[0].retailPrice;
          params.foodBoxPrice = this.goodsForm.products[0].foodBoxPrice || 0;
          params.memberPrice = this.goodsForm.products[0].memberPrice;
          params.costPrice = this.goodsForm.products[0].costPrice;
          params.products = JSON.stringify(params.products);
          params.minBuyNum = Number(params.minBuyNum);
          if (params.isPromote) {
            params.minBuyNum = 0;
          }
          updateGoods(params).then((res) => {
            if (res.code == 1) {
              this.$notify({
                title: "提示",
                message: this.goodsForm.goodsId ? "编辑成功" : "创建成功",
                type: "success",
                duration: 3000,
              });
              // this.$router.go(-1);
              this.$router.push({
                path: "/goods",
                query: {
                  pageNo: this.$route.query.pageNo,
                  menuSel: this.$route.query.menuSel,
                  parentMenuSel: this.$route.query.parentMenuSel,
                },
              });
            } else {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "error",
                duration: 2000,
              });
            }
            this.isSubmit = false;
          });
        } else {
          this.$notify({
            title: "提示",
            message: "请完善提交内容",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
    resetForm(formName) {
      this.fileList = [];
      this.goodsForm = {
        goodsId: this.goodsForm.goodsId ? this.goodsForm.goodsId : "",
        goodsName: "",
        goodsCategoryId: this.goodsForm.goodsCategoryId,
        goodsDescription: "",
        goodsBarCode: "",
        unitType: 1,
        goodsType: 1,
        goodsImage: "",
        unit: "",
        goodsUnitId: "",
        baseSales: 0,
        isRequired: 0,
        isPromote: 0,
        isCanDiscount: 0,
        isCanSaleOffline: 0,
        minBuyNum: 1,
        isSingleNoDelivery: 0,
        isFictitious: 0,
        saleAreaType: 0,
        refundNoAuth: 0,
        tags: "",
        goodsLabel: [],
        groupIds: [],
        products: [
          {
            productId: "",
            retailPrice: "0.00",
            foodBoxPrice: "0.00",
            memberPrice: "0.00",
            barCode: "",
            stockType: "custom",
            stockCount: 1000,
            valueContent: "",
            costPrice: "0.00",
            takePrice: "0.00",
            goodsUnitId: "",
          },
        ],
        freeSpecs: [
          {
            name: "",
            value: [],
            specValueList: [],
            attrValueInputVisible: false,
            attrValueInputValue: "",
          },
        ],
      };
      this.$refs.goodsForm.resetFields();
    },
    addGoodsSpec() {
      if (!this.isAddGoodsSpec) {
        this.isAddGoodsSpec = true;
      } else {
        this.goodsForm.products.push({
          productId: "",
          retailPrice: "1.00",
          foodBoxPrice: "0.00",
          memberPrice: "0.00",
          barCode: "",
          stockType: "custom",
          stockCount: 1000,
          valueContent: "",
        });
      }
    },
    delGoodsSpec(index) {
      if (this.goodsForm.products.length == 1) {
        this.isAddGoodsSpec = false;
        this.goodsForm.products[0].productId = "";
        this.goodsForm.products[0].valueContent = "";
      } else {
        this.goodsForm.products.splice(index, 1);
      }
    },
    addGoodsAttr() {
      this.goodsForm.freeSpecs.push({
        name: "",
        value: [],
        specValueList: [],
        attrValueInputVisible: false,
        attrValueInputValue: "",
      });
    },
    delGoodsAttr(index) {
      this.goodsForm.freeSpecs.splice(index, 1);
    },
    handleClose(tag, index) {
      this.goodsForm.freeSpecs[index].value.splice(
        this.goodsForm.freeSpecs[index].value.indexOf(tag),
        1
      );
    },

    showAttrValueInput(index) {
      this.goodsForm.freeSpecs[index].attrValueInputVisible = true;
      this.$nextTick((_) => {
        this.$refs[`saveTagInput${index}`][0].focus();
      });
    },
    handleAttrValueInputConfirm(index) {
      let attrValueInputValue = this.goodsForm.freeSpecs[index].attrValueInputValue;
      if (attrValueInputValue) {
        this.goodsForm.freeSpecs[index].value.push(attrValueInputValue);
      }
      this.goodsForm.freeSpecs[index].attrValueInputVisible = false;
      this.goodsForm.freeSpecs[index].attrValueInputValue = "";
    },
    numberInputChange(e) {
      if (~e.target.value.indexOf(".") && e.target.value.split(".")[1].length >= 2) {
        e.target.value = Number(e.target.value).toFixed(2);
      }
    },
    numberInputBlur(e) {
      if (e.target.value.indexOf(".") == -1) {
        e.target.value = Number(e.target.value).toFixed(1);
      }
      if (parseInt(e.target.value) < 0) {
        e.target.value = Math.abs(e.target.value);
        this.$notify({
          type: "warning",
          message: "金额不能小于0",
        });
      }
    },
    stockCountInputBlur(e) {
      // let reg = /^[+]{0,1}(\d+)$/;
      // if (!reg.test(e.target.value)) {
      //   this.$notify({
      //     type: "warning",
      //     message: "库存只能是整数",
      //   });
      //   e.target.value = "";
      // }
      if (parseInt(e.target.value) < 0) {
        e.target.value = Math.abs(e.target.value);
        this.$notify({
          type: "warning",
          message: "库存不能小于0",
        });
      }
      if (parseInt(e.target.value) >= 2147483647) {
        e.target.value = Math.abs(2147483647);
        this.$notify({
          type: "warning",
          message: "库存不能大于2147483647",
        });
      }
      if (parseInt(e.target.value) != parseFloat(e.target.value)) {
        e.target.value = parseInt(e.target.value);
        this.$notify({
          type: "warning",
          message: "库存只能是整数",
        });
      }
    },
    copyGoodsUrl() {
      var copyText = document.querySelector(`.goodsUrl`);
      copyText.select();
      document.execCommand("copy");
      this.$notify({
        title: "提示",
        message: "复制成功",
        type: "success",
        duration: 1000,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .tab-header {
    padding: 12px 20px;
  }

  .tab-content {
    padding: 40px 48px;
  }

  .custom-form {
    width: 1480px;
    background: #f8f8f8;
    font-size: 14px;
    color: #606266;
    padding: 12px 0 20px 20px;
    box-sizing: border-box;
    margin-bottom: 10px;

    &.combined {
      padding: 0 0 0 0;

      .form-content {
        background-color: #fff;
        border: 1px solid #e4e4e4;

        .el-link {
          margin-left: 20px;
        }
      }

      .fixed-width {
        width: 200px;
        text-align: center;

        &:first-of-type {
          padding-left: 20px;
          min-width: 200px;
          text-align: left;
          white-space: nowrap;
        }
      }
    }

    .form-header,
    .form-content > .item {
      display: flex;

      & > div {
        margin-right: 20px;
      }

      .fixed-width {
        width: 124px;

        .el-input {
          width: 140px;
        }
      }

      .indefinite-width {
        .el-input {
          width: 100px;
          margin: 0 16px 0 10px;
        }

        .el-tag {
          margin-right: 10px;
        }

        .el-button--text {
          margin-left: 10px;
        }
      }
    }

    & > .el-button {
      margin-top: 18px;
    }
  }

  .el-form-item__content {
    .el-input,
    .el-textarea {
      width: 380px;
    }
  }

  .el-radio {
    margin-right: 20px;

    &:last-child {
      margin-right: 0;
    }
  }
}

.tips {
  font-size: 12px;
  color: red;
  white-space: nowrap;
}

.dialog-selgoods {
  .content-page {
    overflow: hidden;

    .bd {
      height: 100%;

      &.sort {
        height: 100%;
        overflow-y: scroll;

        .tab-header {
          background: #fffcf5;
          border-bottom-color: #f2e7b8;

          .sort-tips {
            display: inline-block;
            font-size: 12px;
            color: #555;
            line-height: 17px;
            margin-left: 20px;
          }
        }

        .tab-content {
          .goods-list {
            width: 100%;
          }
        }
      }
    }

    .tab-header {
      .btn-group-one {
        .upload-xls {
          display: inline-block;
          margin: 0 15px;
        }
      }

      .btn-group-two {
        .el-checkbox {
          margin-right: 15px;
        }
      }
    }

    .tab-content {
      display: flex;
      padding: 0;
      height: 500px;

      .goods-classify-wrap {
        display: flex;
        height: 100%;
        flex-shrink: 0;
      }

      .goods-classify-list {
        width: 120px;
        min-width: 120px;
        height: 100%;
        background: #f8f8f8;
        font-size: 12px;
        overflow: auto;

        li {
          color: #666666;
          padding-left: 20px;
          padding: 15px 20px;
          line-height: 20px;
          border-bottom: 1px solid #eeeeee;
          cursor: pointer;
          width: 80px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          &.active {
            background: #fff;
          }
        }
      }
    }

    .tab-footer {
      text-align: center;
      margin: 10px 0;

      .el-button {
        margin-left: 10px;
      }
    }

    .el-pagination {
      padding: 0;
    }

    .goods-list {
      flex: 1;
      min-width: 0;
      box-sizing: border-box;

      .list-title {
        display: flex;
        padding: 0 20px 0 0;
        line-height: 40px;
        background: #f8f8f8;

        .title {
          box-sizing: border-box;
          padding-left: 10px;
          flex: 1;

          &:first-of-type {
            min-width: 400px;
            max-width: 400px;
            padding-left: 40px;
          }
        }
      }

      .el-checkbox-group {
        height: calc(100% - 96px);
        overflow: auto;
      }

      .search-header {
        line-height: 30px;
        margin: 10px 0;
        font-size: 14px;
        color: #333;
        padding-left: 10px;

        .el-link {
          vertical-align: top;
          line-height: 30px;
          margin-left: 20px;
        }
      }

      &.screen {
        width: 100%;
      }

      .goods-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 0;
        border-bottom: 1px solid #eeeeee;
        box-sizing: border-box;
      }

      .goods-info {
        display: flex;

        .pic {
          position: relative;
          width: 50px;
          height: 50px;
          border-radius: 4px;

          &::before {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.5);
            color: #fff;
            text-align: center;
            line-height: 50px;
            font-size: 12px;
          }

          &.lower-shelf {
            &::before {
              content: "已下架";
            }
          }

          &.sell-out {
            &::before {
              content: "已售罄";
            }
          }

          &.will-sell-out {
            &::before {
              content: "将售罄";
            }
          }
        }

        .info {
          margin-left: 15px;

          .title {
            font-size: 14px;
            line-height: 28px;
            color: #666666;

            .tag-list {
              display: inline-block;

              & > span {
                background: #ee3030;
                color: #fff;
                font-size: 12px;
                border-radius: 3px;
                padding: 0 5px;
              }
            }
          }

          .price {
            font-size: 14px;
            line-height: 22px;
            color: #ee3030;
          }
        }
      }

      .table-action {
        & > span {
          margin: 0 10px;
        }
      }

      .list-none {
        text-align: center;
        font-size: 14px;
        color: #999999;
        padding-top: 200px;

        & > p {
          margin: 10px 0;
        }
      }
    }
  }
}

.dialog-selproducts {
  .content-page {
    .tab-content {
      padding: 0;

      .products-list {
        width: 100%;

        .list-title {
          display: flex;
          padding: 0 20px 0 0;
          line-height: 40px;
          background: #f8f8f8;

          .title {
            box-sizing: border-box;
            padding-left: 10px;
            flex: 1;
          }
        }

        .list-footer {
          .el-button {
            margin-left: 10px;
          }
        }
      }
    }
  }
}

.list-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  padding: 0 10px;
}

.goodsUrl {
  width: 1px;
  height: 1px;
  position: absolute;
  top: 0;
  opacity: 0;
}
</style>
<style lang="less">
.dialog-selgoods {
  .el-checkbox__input.is-disabled + span.el-checkbox__label {
    color: #fff;
    cursor: pointer;
  }

  .el-checkbox__input.is-disabled {
    &.is-checked {
      .el-checkbox__inner {
        background-color: #409eff;
        border-color: #409eff;

        &::after {
          border-color: #fff;
          cursor: pointer;
        }
      }
    }

    .el-checkbox__inner {
      background-color: #fff;
      border-color: #dcdfe6;
      cursor: pointer;

      &::after {
      }
    }
  }
}

.custom-form {
  &.combined {
    .fixed-width {
      .el-input {
        width: 100%;
      }
    }
  }
}
</style>
